import { selectorStore } from '../stores';

export const handleOpenSelector = () => {
  selectorStore.setValue(true);
};

export const handleCloseSelector = () => {
  selectorStore.setValue(false);
};
